import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DetalleCuentaPDFs = () => {
    const pdfs = [
        { mes: 'Julio 2026', filename: 'EdoCta_Jul2026.pdf', size: '245 KB' },
        { mes: 'Junio 2026', filename: 'EdoCta_Jun2026.pdf', size: '250 KB' },
        { mes: 'Mayo 2026', filename: 'EdoCta_May2026.pdf', size: '240 KB' },
        { mes: 'Abril 2026', filename: 'EdoCta_Abr2026.pdf', size: '248 KB' },
        { mes: 'Marzo 2026', filename: 'EdoCta_Mar2026.pdf', size: '242 KB' },
    ];

    return (
        <Card className="h-100 shadow-sm border-0 bg-light">
            <Card.Body className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold text-secondary mb-0">
                        <FontAwesomeIcon icon="file-invoice" className="me-2 text-primary" />
                        Estados de Cuenta
                    </h6>
                    <Button variant="outline-primary" size="sm" title="Subir estado de cuenta">
                        <FontAwesomeIcon icon="upload" />
                    </Button>
                </div>
                <div className="flex-grow-1 overflow-auto pe-1" style={{ maxHeight: '280px' }}>
                    {pdfs.map((pdf, index) => (
                        <div key={index} className="d-flex justify-content-between align-items-center bg-white p-2 rounded mb-2 border shadow-sm" style={{ cursor: 'pointer' }}>
                            <div className="d-flex align-items-center">
                                <div className="bg-danger bg-opacity-10 text-danger rounded px-2 py-2 me-2">
                                    <FontAwesomeIcon icon="file-pdf" className="fs-5" />
                                </div>
                                <div>
                                    <small className="fw-bold d-block text-dark lh-1 mb-1">{pdf.mes}</small>
                                    <span className="text-muted" style={{ fontSize: '0.7rem' }}>{pdf.filename} • {pdf.size}</span>
                                </div>
                            </div>
                            <div>
                                <Button variant="link" size="sm" className="p-1 text-secondary" title="Ver documento">
                                    <FontAwesomeIcon icon="eye" />
                                </Button>
                                <Button variant="link" size="sm" className="p-1 text-secondary" title="Descargar">
                                    <FontAwesomeIcon icon="download" />
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};
